// AUTO-GENERATED GraphQL Builder for BookingPackage
import * as Builders from '../';
export class BookingPackageBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  bookingId(){ return this.add('bookingId'); }
  vendorId(){ return this.add('vendorId'); }
  serviceCategoryId(){ return this.add('serviceCategoryId'); }
  name(){ return this.add('name'); }
  amount(){ return this.add('amount'); }
  vendorCost(){ return this.add('vendorCost'); }
  markup(){ return this.add('markup'); }
  status(){ return this.add('status'); }
  offeringId(){ return this.add('offeringId'); }
  kind(){ return this.add('kind'); }
  eventSessionId(){ return this.add('eventSessionId'); }
  guests(){ return this.add('guests'); }
  offeringPackageId(){ return this.add('offeringPackageId'); }
  extraHeads(){ return this.add('extraHeads'); }
  isBundleHead(){ return this.add('isBundleHead'); }
  bundleOfferingId(){ return this.add('bundleOfferingId'); }
  bundleOfferingPackageId(){ return this.add('bundleOfferingPackageId'); }
  bundleName(){ return this.add('bundleName'); }
  bundleTierName(){ return this.add('bundleTierName'); }
  ownServicesAmount(){ return this.add('ownServicesAmount'); }
  bundleMarkup(){ return this.add('bundleMarkup'); }
  note(){ return this.add('note'); }
  addonSelJson(){ return this.add('addonSelJson'); }
  bundleItemSelJson(){ return this.add('bundleItemSelJson'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  booking(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('booking'))return this;
    this.v.add('booking');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`booking { ${inner} }`);
    return this;
  }

  bundleOffering(b?:(q:Builders.OfferingBuilder)=>void){
    if(this.depth>=5||this.v.has('bundleOffering'))return this;
    this.v.add('bundleOffering');
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bundleOffering { ${inner} }`);
    return this;
  }

  bundleOfferingPackage(b?:(q:Builders.OfferingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bundleOfferingPackage'))return this;
    this.v.add('bundleOfferingPackage');
    const n=new Builders.OfferingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bundleOfferingPackage { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  eventSession(b?:(q:Builders.EventSessionBuilder)=>void){
    if(this.depth>=5||this.v.has('eventSession'))return this;
    this.v.add('eventSession');
    const n=new Builders.EventSessionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`eventSession { ${inner} }`);
    return this;
  }

  offering(b?:(q:Builders.OfferingBuilder)=>void){
    if(this.depth>=5||this.v.has('offering'))return this;
    this.v.add('offering');
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offering { ${inner} }`);
    return this;
  }

  offeringPackage(b?:(q:Builders.OfferingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringPackage'))return this;
    this.v.add('offeringPackage');
    const n=new Builders.OfferingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringPackage { ${inner} }`);
    return this;
  }

  serviceCategory(b?:(q:Builders.ServiceCategoryBuilder)=>void){
    if(this.depth>=5||this.v.has('serviceCategory'))return this;
    this.v.add('serviceCategory');
    const n=new Builders.ServiceCategoryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`serviceCategory { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  vendor(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('vendor'))return this;
    this.v.add('vendor');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendor { ${inner} }`);
    return this;
  }

  bookingDishSelectionList(b?:(q:Builders.BookingDishSelectionBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingDishSelectionList'))return this;
    this.v.add('bookingDishSelectionList');
    const n=new Builders.BookingDishSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingDishSelectionList { ${inner} }`);
    return this;
  }

  bookingItemSelectionList(b?:(q:Builders.BookingItemSelectionBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingItemSelectionList'))return this;
    this.v.add('bookingItemSelectionList');
    const n=new Builders.BookingItemSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingItemSelectionList { ${inner} }`);
    return this;
  }

  bookingPackageItemQtyList(b?:(q:Builders.BookingPackageItemQtyBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackageItemQtyList'))return this;
    this.v.add('bookingPackageItemQtyList');
    const n=new Builders.BookingPackageItemQtyBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageItemQtyList { ${inner} }`);
    return this;
  }

  bookingPackageLineList(b?:(q:Builders.BookingPackageLineBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackageLineList'))return this;
    this.v.add('bookingPackageLineList');
    const n=new Builders.BookingPackageLineBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageLineList { ${inner} }`);
    return this;
  }

  bookingPartnerChangeList(b?:(q:Builders.BookingPartnerChangeBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPartnerChangeList'))return this;
    this.v.add('bookingPartnerChangeList');
    const n=new Builders.BookingPartnerChangeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPartnerChangeList { ${inner} }`);
    return this;
  }

  invoiceLineList(b?:(q:Builders.InvoiceLineBuilder)=>void){
    if(this.depth>=5||this.v.has('invoiceLineList'))return this;
    this.v.add('invoiceLineList');
    const n=new Builders.InvoiceLineBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`invoiceLineList { ${inner} }`);
    return this;
  }

  ledgerEntryList(b?:(q:Builders.LedgerEntryBuilder)=>void){
    if(this.depth>=5||this.v.has('ledgerEntryList'))return this;
    this.v.add('ledgerEntryList');
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntryList { ${inner} }`);
    return this;
  }

  partnerApprovalList(b?:(q:Builders.PartnerApprovalBuilder)=>void){
    if(this.depth>=5||this.v.has('partnerApprovalList'))return this;
    this.v.add('partnerApprovalList');
    const n=new Builders.PartnerApprovalBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`partnerApprovalList { ${inner} }`);
    return this;
  }

  reverseBookingDishSelection(b?:(q:Builders.BookingDishSelectionBuilder)=>void){
    const n=new Builders.BookingDishSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingDishSelectionList { ${inner} }`);
    return this;
  }

  reverseBookingItemSelection(b?:(q:Builders.BookingItemSelectionBuilder)=>void){
    const n=new Builders.BookingItemSelectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingItemSelectionList { ${inner} }`);
    return this;
  }

  reverseBookingPackageItemQty(b?:(q:Builders.BookingPackageItemQtyBuilder)=>void){
    const n=new Builders.BookingPackageItemQtyBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageItemQtyList { ${inner} }`);
    return this;
  }

  reverseBookingPackageLine(b?:(q:Builders.BookingPackageLineBuilder)=>void){
    const n=new Builders.BookingPackageLineBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageLineList { ${inner} }`);
    return this;
  }

  reverseBookingPartnerChange(b?:(q:Builders.BookingPartnerChangeBuilder)=>void){
    const n=new Builders.BookingPartnerChangeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPartnerChangeList { ${inner} }`);
    return this;
  }

  reverseInvoiceLine(b?:(q:Builders.InvoiceLineBuilder)=>void){
    const n=new Builders.InvoiceLineBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`invoiceLineList { ${inner} }`);
    return this;
  }

  reverseLedgerEntry(b?:(q:Builders.LedgerEntryBuilder)=>void){
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntryList { ${inner} }`);
    return this;
  }

  reversePartnerApproval(b?:(q:Builders.PartnerApprovalBuilder)=>void){
    const n=new Builders.PartnerApprovalBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`partnerApprovalList { ${inner} }`);
    return this;
  }
}
